import React, { Component } from 'react'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { QuoteMark } from './icons'

class FeaturedTeamMembers extends Component {

  state = {
    teamMember: null
  }

  constructor(props) {
    super(props);
    this.state = {teamMember: props.items[0]};
  }

  _setTeamMember = (key) => {
    let { items } = this.props
    let { teamMember } = this.state
    teamMember = items[key]
    this.setState({ teamMember })
  }

  render() {

    let { items } = this.props

    let { teamMember } = this.state

    return (
      <section className='featured-team-members'>
        <div className='featured-team-members__inner'>

          { teamMember &&
            <>
            <div className='featured-team-members__link'>
              <Link className='btn' to={`/team/${teamMember.slug}/`}>View Profile</Link>
            </div>
            <div className='featured-team-members__quote featured-team-members__quote--desktop'>
              <QuoteMark color='#91A0C1' />
              <h4>{ teamMember.acf.quote  }</h4>
            </div>
            </>
          }

          <div className='featured-team-members__content'>

            { items &&
              <div className='featured-team-members__menu'>

                <ul>
                {items.map((el, i) => (
                  <li className={ ( teamMember.id === el.id ) ? `active` : '' } onClick={() => this._setTeamMember(i)} key={i}>{ el.title }</li>
                ))}
                </ul>

              </div>
            }

            { teamMember &&
            <>

              <div className='featured-team-members__quote featured-team-members__quote--mobile'>
                <QuoteMark color='#91A0C1' />
                <h4>{ teamMember.acf.quote  }</h4>
              </div>
              
              <div className='featured-team-members__bio'>

                <div className='bio' dangerouslySetInnerHTML={{ __html: teamMember.acf.aboutBio }} />

                <div className='bio' dangerouslySetInnerHTML={{ __html: teamMember.acf.aboutBioRightColumn }} />

              </div>

              <div className='featured-team-members__image'>
                <img loading='lazy' src={teamMember.acf.profileImage?.sourceUrl} alt={teamMember.title} />
              </div>

            </>
            }

          </div>
        </div>
      </section>
    )
  }
}

export default FeaturedTeamMembers
